import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer-area row pc" }
const _hoisted_4 = { class: "left col-2" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"right col-10\"><p class=\"copy\">NUMBERS21 PTE. LTD. All right reserved. | <a class=\"email\" href=\"mailto:Contact@Atube.video\">Contact@Atube.video</a></p><div class=\"sns-area\"><a class=\"twit\" href=\"https://twitter.com/artube_token\" target=\"_blank\"></a><a class=\"direct\" href=\"https://t.me/att_chat\" target=\"_blank\"></a><a class=\"youtube\" href=\"https://url.kr/a95oy1\" target=\"_blank\"></a><a class=\"medium\" href=\"https://medium.com/artube\" target=\"_blank\"></a></div></div>", 1)
const _hoisted_6 = { class: "footer-area mb" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"sns-area\"><a class=\"twit\" href=\"https://twitter.com/artube_token\" target=\"_blank\"></a><a class=\"direct\" href=\"https://t.me/att_chat\" target=\"_blank\"></a><a class=\"youtube\" href=\"https://url.kr/a95oy1\" target=\"_blank\"></a></div><div class=\"sns-area mb\"><a class=\"medium\" href=\"https://medium.com/artube\" target=\"_blank\"></a></div>", 2)
const _hoisted_9 = { class: "" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "copy" }, [
  /*#__PURE__*/_createTextVNode("NUMBERS21 PTE. LTD. All right reserved. | "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "email",
    href: "mailto:Contact@Atube.video"
  }, "Contact@Atube.video")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickLogo()))
          })
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h1", {
            class: "logo",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickLogo()))
          }),
          _hoisted_10
        ])
      ])
    ])
  ]))
}